// Libs
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Services
import ApiServiceV2 from 'services/apiService/apiServiceV2';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
import { reloadDatasource } from 'core/actions';
// Selectors
import { selectProfile } from 'screens/Login/selectors';
// Components
import { DeleteIcon, LogoIcon } from 'components';

// role_id = 31: Gestor de catálogo de inventario L2
const CATALOGUE_L2_ROLE = 31;

const DeleteCatalogItem = ({ itemIds = [] }) => {
	const [isFetching, setIsFetching] = useState(false);
	const dispatch = useDispatch();
	const profile = useSelector(selectProfile);

	const canDelete = !!profile?.user?.roles?.[CATALOGUE_L2_ROLE];
	if (!canDelete) return null;

	const handleDelete = async () => {
		setIsFetching(true);

		const results = await Promise.allSettled(
			itemIds.map(id => ApiServiceV2.delete({ url: `/items/${id}` })),
		);

		const failed = results.filter(r => r.status === 'rejected');
		const succeeded = results.length - failed.length;

		if (succeeded > 0) {
			dispatch(
				sendToast({
					message: `${succeeded} artículo${succeeded > 1 ? 's eliminados' : ' eliminado'}`,
					type: 'success',
					duration: 3,
				}),
			);
			dispatch(reloadDatasource());
		}

		if (failed.length > 0) {
			const firstMessage =
				failed[0].reason?.response?.data?.message ||
				'Error al eliminar uno o más artículos';
			dispatch(
				sendToast({
					message:
						failed.length > 1
							? `${failed.length} artículos no pudieron eliminarse: ${firstMessage}`
							: firstMessage,
					type: 'error',
					duration: 5,
				}),
			);
		}

		setIsFetching(false);
	};

	if (isFetching) return <LogoIcon spin />;
	return <DeleteIcon button onClick={handleDelete} />;
};

export default DeleteCatalogItem;
